import config from '../../config'
import { buildGetQuery } from '../../util'

import { IGetRequestObject } from '../../interfaces'

import { ISafetyCaseRiskMatrix } from '../../interfaces/services/safety-case-risk-matrix'

const getSafetyCaseRiskMatrixRequest = (): IGetRequestObject => ({
  method: 'get',
  url: `${config.baseUrl}/sms/RiskMatrix`,
})

const useSafetyCaseRiskMatrixQuery = buildGetQuery<undefined, undefined, ISafetyCaseRiskMatrix | undefined>({
  getRequest: getSafetyCaseRiskMatrixRequest,
  getQueryKey: () => ['safety-case-risk-matrix'],
})

export default useSafetyCaseRiskMatrixQuery
